import * as React from 'react';
import { observer } from 'mobx-react';
import { ReleaseTrack } from './release-track';
import { style } from 'typestyle';
import { ContainerQuery } from 'react-container-query';
import {TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';
import {AnalyticsController} from "../modules/analytics/controller";

export interface ReleaseTracksModel {
  tracks: Array<TrackSchema>;
  highlight?: string;
  loading: boolean;
}

export interface ReleaseTracksProps {
  model: ReleaseTracksModel;
  pageSize?: number;
  PlayButton: any;
  BrandSponsoredLabel: any;
  Favourite: any;
  isMobile: boolean;
  AddRemove: any;
  preloadWaveform: ImagePreloader;
  onClickLink(event: React.MouseEvent<any>): any;
  analytics: AnalyticsController;
}

@observer
export class ReleaseTracks extends React.Component<ReleaseTracksProps, any> {
  render() {
    const { model, PlayButton, Favourite, AddRemove, BrandSponsoredLabel, pageSize = 12, onClickLink, preloadWaveform, isMobile, analytics } = this.props;

    // destructure to force re-render of container query if model changes
    const { tracks, loading } = model;

    return (
      <ContainerQuery query={ReleaseTracks.query} children={(params: any) => (
        <div className={ReleaseTracks.styles.container}>
          {model.tracks.map((track, index) => (
            <ReleaseTrack
              key={track.identity}
              track={track}
              PlayButton={PlayButton}
              AddRemove={AddRemove}
              onClickLink={onClickLink}
              preloadWaveform={preloadWaveform}
              isMobile={params.isMobile || isMobile}
              Favourite={Favourite}
              BrandSponsoredLabel={BrandSponsoredLabel}
              highlight={model.highlight}
              analytics={analytics}
            />
          ))}
        </div>
      )} />
    )
  }

  static styles = {
    container: style({
      padding: '0.5rem 0'
    }),
  };

  static query = {
    isMobile: {
      maxWidth: 600,
    }
  }
}